const ALLOWED_VIDEO_TYPES = ["video/mp4", "video/quicktime"];
const ALLOWED_VIDEO_EXTENSIONS = [".mp4", ".mov"];
const MAX_VIDEO_SIZE_BYTES = 100 * 1024 * 1024;

const hasAllowedExtension = (filename = "") => {
  const lower = filename.toLowerCase();
  return ALLOWED_VIDEO_EXTENSIONS.some((extension) => lower.endsWith(extension));
};

export const validateVideoFile = (file) => {
  const mimeValid = ALLOWED_VIDEO_TYPES.includes(file.type);
  const extensionValid = hasAllowedExtension(file.name);

  if (!mimeValid || !extensionValid) {
    throw new Error("invalid_type");
  }

  if (file.size > MAX_VIDEO_SIZE_BYTES) {
    throw new Error("too_large");
  }
};

export const getVideoUploadErrorMessageKey = (errorCode) => {
  if (errorCode === "invalid_type") return "invalidType";
  if (errorCode === "too_large") return "tooLarge";
  return "validationFailed";
};
